import './../App.css';
import '../css/pages/realisations.css';
import { useEffect, useState, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import { FooterComponent, FooterMainComponent } from '../components/MainComponents';
import Axios from 'axios'
import { apiUrl } from '../constants/Constants';
import { Link, useLocation, NavLink, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;


mapboxgl.accessToken = 'pk.eyJ1IjoiamFzb25zZW04OCIsImEiOiJjbDJwejY0bWgxdm9pM2JwazJpYnY3a3kwIn0.q2rVceGa016EwXht2oqU-Q'


function Realisations() {

    const [listFiltered, setlistFiltered] = useState([])
    const [chantiersImagesList, setChantiersImagesList] = useState([]);
    const [mobilenav, setMobilenav] = useState(false)

    const [carousel, setCarousel] = useState(false);
    const [carouselindex, setCarouselIndex] = useState(-1);
    const [carouselindex2, setCarouselIndex2] = useState(-1);
    const [carouselindex3, setCarouselIndex3] = useState(-1);
    const [carouseltitle, setCarouselTitle] = useState("");
    const [carouseltype, setCarouselType] = useState("");
    const [carouselpic, setCarouselPic] = useState("");
    const [carouseldesc, setCarouselDesc] = useState("");
    const [carouseladdresse, setCarouselAddresse] = useState("");
    const [carouselimageindex, setCarouselImageIndex] = useState(0)
    const [carouselmobile, setCarouselMobile] = useState(false)
    const [selected, setSelected] = useState("")

    const [arraypag, setArrayPag] = useState([])
    const [currentpag, setCurrentPag] = useState(0)
    const [startpag, setStartPag] = useState(0)
    const [endpag, setEndPag] = useState(6)

    const [smallcarouselimages, setSmallCarouselImages] = useState([]);

    const [isFullScreen, setIsFullScreen] = useState(false);

    const [isloading, setIsLoading] = useState(false)

    const navigation = useNavigate();

    const ref = useRef(null);

    const imageRef = useRef(null);

    const handleFullScreen = () => {
        if (isFullScreen) {
            document.exitFullscreen();
        } else {
            imageRef.current.requestFullscreen();
        }
        setIsFullScreen(!isFullScreen);
    };

    const scrollToCarousel = (id, index, ch_nom, ch_type, ch_desc, ch_addresse, pic) => {

        setCarouselImageIndex(0)

        if (carousel == false) {
            getCarouselFilteredImages(id);
            //index <= 2 ? setCarouselIndex(0) : setCarouselIndex(3);
            setCarouselIndex(index - index % 3)
            setCarousel(true);
            //index <= 1 ? setCarouselIndex2(0) : index <= 3 ? setCarouselIndex2(2) : setCarouselIndex2(4);
            setCarouselIndex2(index - index % 2)
            setCarouselIndex3(index)
            setCarouselTitle(ch_nom);
            setCarouselType(ch_type);
            setCarouselDesc(ch_desc);
            setCarouselAddresse(ch_addresse);
            setCarouselPic(pic);
            setTimeout(function () {
                const topOfElement = document.querySelector('#my-carousel').offsetTop - 70;
                window.scroll({ top: topOfElement, behavior: "smooth" });
            }, 200);
            setIsLoading(true)
        }
        else {

            if (index == carouselindex3) {
                setCarousel(false);
                setCarouselIndex(-1)
                setCarouselIndex2(-1)
                setCarouselIndex3(-1)
                setCarouselTitle("");
                setCarouselType("");
                setCarouselDesc("");
                setCarouselAddresse("");
                setCarouselPic("");
                setSelected("")

            } else {
                getCarouselFilteredImages(id);
                //index <= 2 ? setCarouselIndex(0) : setCarouselIndex(3);
                setCarouselIndex(index - index % 3)
                setCarousel(true);
                //index <= 1 ? setCarouselIndex2(0) : index <= 3 ? setCarouselIndex2(2) : setCarouselIndex2(4);
                setCarouselIndex2(index - index % 2)
                setCarouselIndex3(index)
                setCarouselTitle(ch_nom);
                setCarouselType(ch_type);
                setCarouselDesc(ch_desc);
                setCarouselAddresse(ch_addresse);
                setCarouselPic(pic);
                setTimeout(function () {
                    const topOfElement = document.querySelector('#my-carousel').offsetTop - 70;
                    window.scroll({ top: topOfElement, behavior: "smooth" });
                }, 200);
                setIsLoading(true)
            }
        }
    }

    const scrollToList = (first, last, current) => {
        setStartPag(first);
        setEndPag(last);
        setCurrentPag(current)
        const topOfElement = document.querySelector('#items-list').offsetTop - 70;
        window.scroll({ top: topOfElement, behavior: "smooth" });
        setCarousel(false);
        setCarouselIndex(-1)
        setCarouselIndex2(-1)
        setCarouselIndex3(-1)
        setCarouselTitle("");
        setCarouselType("");
        setCarouselDesc("");
        setCarouselAddresse("");
        setCarouselPic("");
        setSelected("")
    }

    const getpicIndex = (pic) => {
        const myindex = chantiersImagesList.findIndex(obj => obj.ch_img === pic);
        setSelected(pic);
        increaseCarousel(myindex);
    }

    const increaseCarousel = (inc) => {
        if (inc == -1) {
            if (carouselimageindex == chantiersImagesList.length - 1) {
                setCarouselImageIndex(0)
                if (smallcarouselimages.findIndex(obj => obj.ch_img === chantiersImagesList[carouselimageindex].ch_img) == 3) {
                    increaseSmallCarousel()
                }
                setSelected(chantiersImagesList[0].ch_img)
            }
            else {
                setCarouselImageIndex(prev => prev + 1)
                if (smallcarouselimages.findIndex(obj => obj.ch_img === chantiersImagesList[carouselimageindex].ch_img) == 3) {
                    increaseSmallCarousel()
                }
                setSelected(chantiersImagesList[carouselimageindex + 1].ch_img)
            }
        }
        else {
            setCarouselImageIndex(inc)
        }
    }

    const decreaseCarousel = (dec) => {
        if (dec == -1) {
            if (carouselimageindex == 0) {
                setCarouselImageIndex(chantiersImagesList.length - 1)
                if (smallcarouselimages.findIndex(obj => obj.ch_img === chantiersImagesList[carouselimageindex].ch_img) == 0) {
                    decreaseSmallCarousel()
                }
                setSelected(chantiersImagesList[chantiersImagesList.length - 1].ch_img)
            }
            else {
                setCarouselImageIndex(prev => prev - 1)
                if (smallcarouselimages.findIndex(obj => obj.ch_img === chantiersImagesList[carouselimageindex].ch_img) == 0) {
                    decreaseSmallCarousel()
                }
                setSelected(chantiersImagesList[carouselimageindex - 1].ch_img)
            }
        }


    }

    const increaseSmallCarousel = () => {

        const newItems = [...smallcarouselimages];
        newItems.push(newItems.shift());
        setSmallCarouselImages(newItems);
    }

    const decreaseSmallCarousel = () => {

        const newItems = [...smallcarouselimages];
        newItems.unshift(newItems.pop());
        setSmallCarouselImages(newItems);
    }

    const increasePag = () => {
        if (currentpag + 1 == arraypag?.[4]) {
            const newItems = [...arraypag];
            newItems.push(newItems.shift());
            setArrayPag(newItems);
            scrollToList((currentpag + 1) * 6, (currentpag + 2) * 6, currentpag + 1)
        } else {
            scrollToList((currentpag + 1) * 6, (currentpag + 2) * 6, currentpag + 1)
        }
        setCarousel(false);
        setCarouselIndex(-1)
        setCarouselIndex2(-1)
        setCarouselIndex3(-1)
        setCarouselTitle("");
        setCarouselType("");
        setCarouselDesc("");
        setCarouselAddresse("");
        setCarouselPic("");
        setSelected("")
    }

    const decreasePag = () => {
        if (currentpag + 1 == arraypag?.[0]) {
            const newItems = [...arraypag];
            newItems.unshift(newItems.pop());
            setArrayPag(newItems);
            scrollToList((currentpag - 1) * 6, (currentpag) * 6, currentpag - 1)
        } else {
            scrollToList((currentpag - 1) * 6, (currentpag) * 6, currentpag - 1)
        }
        setCarousel(false);
        setCarouselIndex(-1)
        setCarouselIndex2(-1)
        setCarouselIndex3(-1)
        setCarouselTitle("");
        setCarouselType("");
        setCarouselDesc("");
        setCarouselAddresse("");
        setCarouselPic("");
        setSelected("")
    }

    const filterListRealisations = (data) => {
        if (data == "all") {

            const filterList = global.chlist.filter((auto) => {
                if (!auto.ch_onlyMap.includes("Non")) {
                    return false
                }
                return auto
            })

            setlistFiltered(filterList)
            setArrayPag(Array.from({ length: Math.ceil(filterList.length / 6) }, (x, i) => i + 1))
            setCurrentPag(0)
            setStartPag(0)
            setEndPag(6)

        }
        else {
            const filterList = global.chlist.filter((auto) => {
                if (!auto.ch_type.includes(data)) {
                    return false
                }
                if (!auto.ch_onlyMap.includes("Non")) {
                    return false
                }
                return auto
            })

            setlistFiltered(filterList)
            setArrayPag(Array.from({ length: Math.ceil(filterList.length / 6) }, (x, i) => i + 1))
            setCurrentPag(0)
            setStartPag(0)
            setEndPag(6)
        }

    }

    function topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    const mapFunc = () => {
        const map = new mapboxgl.Map(
            {
                container: 'map',
                style: 'mapbox://styles/mapbox/streets-v11',
                center: [2.3522, 48.8566],
                zoom: 11,
                attributionControl: false
            }).addControl(new mapboxgl.FullscreenControl({ container: document.querySelector('mainCont') }))
        for (let i = 0; i < global.chlist.length; i++) {
            if (global.chlist[i].ch_onlyMap === "Non" || global.chlist[i].ch_onlyMap === null) {
                const marker = new mapboxgl.Marker({ "color": "#e13939" })
                    .setLngLat([global.chlist[i].ch_long, global.chlist[i].ch_lat])
                    .setPopup(new mapboxgl.Popup({ className: 'markerPopUp' }).setHTML("<text class='text-13 bold'>" + global.chlist[i].ch_nom + "</text><br/><text>" + global.chlist[i].ch_type + "</text><br/>"))
                    .addTo(map);
            } else {
                const marker = new mapboxgl.Marker({ "color": "#e13939" })
                    .setLngLat([global.chlist[i].ch_long, global.chlist[i].ch_lat])
                    .setPopup(new mapboxgl.Popup({ className: 'markerPopUp' }).setHTML("<text class='text-13 bold'>" + global.chlist[i].ch_nom + "</text><br/><text>" + global.chlist[i].ch_type + "</text>"))
                    .addTo(map);
            }
        }
    }

    const getCarouselFilteredImages = (ch_id) => {
        const filterCarouselList = global.listAllImages.filter((auto) => auto.ch_id == ch_id)
        setChantiersImagesList(filterCarouselList)
        setSmallCarouselImages(filterCarouselList)
        setSelected(filterCarouselList[0]?.ch_img)
    }

    const getChantiersApi = () => {
        setIsLoading(true)
        document.body.style.overflow = "hidden"
        Axios.get(apiUrl + 'getChantier.php')
            .then((responseJson) => {
                if (responseJson.data === '0 results') {
                    setTimeout(() => {
                        setIsLoading(false)
                        document.body.style.overflow = "visible"
                    }, 3000);
                }
                else {
                    global.chlist = responseJson.data;
                    if (global.globalType == "all") {
                        const filterList = responseJson.data.filter((auto) => {
                            if (!auto.ch_onlyMap.includes("Non")) {
                                return false
                            }
                            return auto
                        })

                        setlistFiltered(filterList)
                        setArrayPag(Array.from({ length: Math.ceil(filterList.length / 6) }, (x, i) => i + 1))
                    }
                    else {
                        const filterList = responseJson.data.filter((auto) => {
                            if (!auto.ch_type.includes(global.globalType)) {
                                return false
                            }
                            if (!auto.ch_onlyMap.includes("Non")) {
                                return false
                            }
                            return auto
                        })
                        setlistFiltered(filterList)
                        setArrayPag(Array.from({ length: Math.ceil(filterList.length / 6) }, (x, i) => i + 1))
                    }
                    getAllImagesApi()
                    mapFunc()
                }
            }
            );
    }

    const getAllImagesApi = () => {
        Axios.get(apiUrl + 'selectAllImages.php')
            .then((responseJson) => {
                if (responseJson.data === '0 results') {
                    setTimeout(() => {
                        setIsLoading(false)
                        document.body.style.overflow = "visible"
                    }, 3000);
                }
                else {
                    global.listAllImages = responseJson.data;
                    setTimeout(() => {
                        setIsLoading(false)
                        document.body.style.overflow = "visible"
                    }, 3000);

                }
            }
            );
    }

    const getMarginTop = (i) => {
        if (carouselmobile && (i % 2 == 0)) {
            return "my-margin-top"
        }
        else if (!carouselmobile && (i % 3 == 0)) {
            return "my-margin-top"
        }

        return ""
    }

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 575) {
                setCarouselMobile(false);
            } else {
                setCarouselMobile(true)
            }
        }

        handleResize();
        window.addEventListener("resize", handleResize);

    }, [window.innerWidth]);


    useEffect(() => {
        global.globalType == null ? global.globalType = "all" : global.globalType = global.globalType;
        getChantiersApi();


        document.getElementById("entreprise").classList.remove('onLinkFocus'); document.getElementById("competence").classList.remove('onLinkFocus'); document.getElementById("realisation").classList.add('onLinkFocus'); document.getElementById("contact").classList.remove('onLinkFocus'); document.documentElement.scrollTop = 0


        if (global.globalType === "all") {
            document.getElementById("all").classList.add('active'); document.getElementById("rco").classList.remove('active'); document.getElementById("rcu").classList.remove('active'); document.getElementById("rsdb").classList.remove('active'); document.getElementById("rsm").classList.remove('active'); document.getElementById("carte").classList.remove('active');
        }
        else if (global.globalType === "Rénovation Complète") {
            document.getElementById("rco").classList.add('active'); document.getElementById("all").classList.remove('active'); document.getElementById("rcu").classList.remove('active'); document.getElementById("rsdb").classList.remove('active'); document.getElementById("rsm").classList.remove('active'); document.getElementById("carte").classList.remove('active');
        } else if (global.globalType === "Rénovation Cuisine") {
            document.getElementById("rco").classList.remove('active'); document.getElementById("all").classList.remove('active'); document.getElementById("rcu").classList.add('active'); document.getElementById("rsdb").classList.remove('active'); document.getElementById("rsm").classList.remove('active'); document.getElementById("carte").classList.remove('active');
        } else if (global.globalType === "Rénovation Salle de Bain") {
            document.getElementById("rco").classList.remove('active'); document.getElementById("all").classList.remove('active'); document.getElementById("rcu").classList.remove('active'); document.getElementById("rsdb").classList.add('active'); document.getElementById("rsm").classList.remove('active'); document.getElementById("carte").classList.remove('active');
        } else if (global.globalType === "Rénovation Sols et Murs") {
            document.getElementById("rco").classList.remove('active'); document.getElementById("all").classList.remove('active'); document.getElementById("rcu").classList.remove('active'); document.getElementById("rsdb").classList.remove('active'); document.getElementById("rsm").classList.add('active'); document.getElementById("carte").classList.remove('active');
        }

    }, [])

    const location = useLocation()

    useEffect(() => {
        if (location.hash) {
            let elem = document.getElementById(location.hash.slice(1))
            if (elem) {
                setTimeout(function () {
                    elem.scrollIntoView({ behavior: "smooth" })
                }, 1000);
            }
        } else {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
        }

    }, [location,])

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 992) {
                setMobilenav(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);

    }, [window.innerWidth]);

    return (
        <div>

            {isloading && <div class="my-loader-container"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>}
            <Helmet>
                <title>Décohome75 - Réalisations</title>
                <meta name="description" content="Décohome75 est une entreprise de rénovation intégrale pour maison basée à Paris, France, spécialisée dans les rénovations de salle de bain, cuisine, murs et sols. Nous proposons des services de maçonnerie, plomberie, menuiserie, peinture et plâtrerie, électricité générale, parqueterie et carrelage." />

                <meta name="keywords" content="rénovation, maison, rénovation intégrale, rénovation complète, salle de bain, cuisine, murs et sols, maçonnerie, plomberie, menuiserie, peinture et plâtrerie, électricité générale, parqueterie, carrelage, paris, france" />
                <meta name="robots" content="index, follow" />
            </Helmet>

            {/* navbar */}

            <div class="home-navbar">
                <div class="container mynavbar-container" >
                    <div class="">
                        <Link
                            to="/"
                            className="my-navbar-logo"
                            onClick={() => topFunction()}
                        ><img src="../assets/images/logo-dark.png" alt="" /></Link>
                    </div>
                    <div className='mynvabar-links'>
                        <NavLink
                            to="/entreprise"
                            id="entreprise"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Qui sommes-nous
                        </NavLink>
                        <NavLink
                            to="/competence"
                            id="competence"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Compétences
                        </NavLink>
                        <NavLink
                            to="/realisation"
                            id="realisation"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Nos Réalisations
                        </NavLink>
                        <NavLink
                            to="/contact"
                            id="contact"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Devis et Contact
                        </NavLink>

                    </div>
                    <div className='mynavbar-icon' onClick={() => { setMobilenav(!mobilenav) }}>
                        <i class="fa fa-bars" aria-hidden="true"></i>
                    </div>
                </div>
                <div className={`mynavbar-mobile-container ${mobilenav ? "mynavbar-mobile-container-visible" : ""}`}>
                    <div className='container mynavbar-links-mobile noPadding'>
                        <NavLink
                            to="/entreprise"
                            id="entreprise"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Qui sommes-nous
                        </NavLink>
                        <NavLink
                            to="/competence"
                            id="competence"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Compétences
                        </NavLink>
                        <NavLink
                            to="/realisation"
                            id="realisation"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Nos Réalisations
                        </NavLink>
                        <NavLink
                            to="/contact"
                            id="contact"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Devis et Contact
                        </NavLink>
                    </div>
                </div>
            </div>

            {/* Nos realisations list */}

            <section class="home-nosrealisations-area" id="portfolio">
                <div>
                    <div class="nosrealisationsHeader">
                        <div class="nosrealisationsTitle">
                            Nos réalisations<span>.</span>
                        </div>
                        <h2 class="nosrealisationsDesc">Le souci du détail rend notre travail excellent</h2>
                        <hr class="home-hr" ></hr>
                    </div>
                    <div class="container align-center">
                        <div class="works-filter">
                            <a id='all' class="filter active" data-filter=".branding" onClickCapture={() => { global.globalType = 'all'; filterListRealisations("all"); document.getElementById("all").classList.add('active'); document.getElementById("rco").classList.remove('active'); document.getElementById("rcu").classList.remove('active'); document.getElementById("rsdb").classList.remove('active'); document.getElementById("rsm").classList.remove('active'); document.getElementById("carte").classList.remove('active'); }}>Tout</a>
                            <a id='rco' class="filter" data-filter=".branding" onClickCapture={() => { ; global.globalType = 'rco'; filterListRealisations("Rénovation Complète"); document.getElementById("all").classList.remove('active'); document.getElementById("rco").classList.add('active'); document.getElementById("rcu").classList.remove('active'); document.getElementById("rsdb").classList.remove('active'); document.getElementById("rsm").classList.remove('active'); document.getElementById("carte").classList.remove('active'); }}>Rénovation Complète</a>
                            <a id='rcu' class="filter" data-filter=".branding" onClickCapture={() => { ; global.globalType = 'rcu'; filterListRealisations("Rénovation Cuisine"); document.getElementById("rco").classList.remove('active'); document.getElementById("all").classList.remove('active'); document.getElementById("rcu").classList.add('active'); document.getElementById("rsdb").classList.remove('active'); document.getElementById("rsm").classList.remove('active'); document.getElementById("carte").classList.remove('active'); }}>Rénovation Cuisine</a>
                            <a id='rsdb' class="filter" data-filter=".design" onClickCapture={() => { ; global.globalType = 'rsdb'; filterListRealisations("Rénovation Salle de Bain"); document.getElementById("rco").classList.remove('active'); document.getElementById("all").classList.remove('active'); document.getElementById("rcu").classList.remove('active'); document.getElementById("rsdb").classList.add('active'); document.getElementById("rsm").classList.remove('active'); document.getElementById("carte").classList.remove('active'); }}>Rénovation Salle de Bain</a>
                            <a id='rsm' class="filter" data-filter=".photography" onClickCapture={() => { ; global.globalType = 'rsm'; filterListRealisations("Rénovation Sols et Murs"); document.getElementById("rco").classList.remove('active'); document.getElementById("all").classList.remove('active'); document.getElementById("rcu").classList.remove('active'); document.getElementById("rsdb").classList.remove('active'); document.getElementById("rsm").classList.add('active'); document.getElementById("carte").classList.remove('active'); }}>Rénovation sols et murs</a>
                            <a style={{ display: "none" }} id='carte' href='#map' class="filter" data-filter=".photography" onClickCapture={() => { ; document.getElementById("Rénovation Complète").classList.remove('active'); document.getElementById("all").classList.remove('active'); document.getElementById("rcu").classList.remove('active'); document.getElementById("rsdb").classList.remove('active'); document.getElementById("rsm").classList.remove('active'); document.getElementById("carte").classList.add('active'); }}> <span class="onLinkFocus">Carte</span></a>

                        </div>
                    </div>
                    <div id='items-list' className="row noMargin">

                        {listFiltered.slice(startpag, endpag).map((data, index) => {

                            let pic = "https://decohome75.fr/api/" + data.ch_img;
                            let picurl = "https://decohome75.fr/api/";

                            return (
                                <div className={`col-6 col-sm-4 noPadding`}>
                                    <div className=''>
                                        <div onClickCapture={() => {
                                            scrollToCarousel(data?.id, index, data?.ch_nom, data?.ch_type, data?.ch_desc, data?.ch_addresse, pic);
                                        }} class="nosrealisationsItems cursor-pointer">
                                            <div class="nosrealisations-items-container">
                                                <div class={`nosrealisationsImage ${carousel && index == carouselindex3 ? "nosrealisationsImageFocus" : ""}`} alt="Work" style={{ backgroundImage: `url(${pic})` }}></div>

                                                {/* <img class={`nosrealisationsImage ${carousel && index == carouselindex3 ? "nosrealisationsImageFocus" : ""}`} src={pic} alt="Work" /> */}

                                                <div class="nosrealisationsText2">
                                                    <h3 style={{ color: carousel && index == carouselindex3 ? "white" : "transparent" }} class="">{data.ch_nom}</h3>
                                                    <div style={{ color: carousel && index == carouselindex3 ? "#999" : "transparent" }} class="">
                                                        {data.ch_type}
                                                    </div>
                                                </div>
                                            </div>

                                            {carousel && index == carouselindex3 ? <div class="home-arrow-down"><i class="fa fa-caret-down" aria-hidden="true"></i></div> : <></>}
                                            <div class="nosrealisationsText" style={{ visibility: carousel && index == carouselindex3 ? "hidden" : "visible", height: carousel && index == carouselindex3 ? "0" : "auto" }}>
                                                <h3 class="">{data.ch_nom}</h3>
                                                <div class="">
                                                    {data.ch_type}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {(carouselmobile ? index == carouselindex2 : index == carouselindex) && carousel ?
                                        <div id='my-carousel' class={`col-12 noMargin home-realisation-carousel-container row ${getMarginTop(carouselindex3)}`}>
                                            <div className='col-lg-3 home-carousel-item1 noPadding'>
                                                <div className='home-carousel-title'>{carouseltitle}</div>
                                                <div className='home-carousel-type'>{carouseltype}</div>
                                                {carouseladdresse && <div className='home-carousel-location'><i class="fa fa-map-marker home-carousel-icon"></i>
                                                    {carouseladdresse}</div>}
                                                <div className='home-carousel-description'>
                                                    {carouseldesc}
                                                </div>
                                            </div>
                                            <div className='col-lg-9 home-carousel-item2 noPadding d-flex flex-column'>
                                                <div className='d-flex align-items-center justify-content-between w-100'>
                                                    <div class="cursor-pointer home-carousel-arrows" onClick={() => decreaseCarousel(-1)}><i class="fa fa-angle-left "></i></div>

                                                    <div class="home-carousel-image-container">
                                                        <div class="carousel-img-smallcarousel-container">
                                                            <div style={{ position: "relative" }}>
                                                                <img ref={imageRef} onLoad={() => {
                                                                    setTimeout(() => {
                                                                        setIsLoading(false)
                                                                    }, 2000);
                                                                }} onClick={handleFullScreen} class="home-carousel-image cursor-pointer" src={chantiersImagesList[carouselimageindex] ? picurl + chantiersImagesList[carouselimageindex].ch_img : carouselpic} alt="Work" />
                                                                <div class="home-carousel-status">
                                                                    {chantiersImagesList[carouselimageindex]?.img_status}
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="cursor-pointer home-carousel-arrows" onClick={() => increaseCarousel(-1)}><i class="fa fa-angle-right"></i></div>
                                                </div>
                                                <div class="carousel-smallcarousel">

                                                    <div class="cursor-pointer home-carousel-arrows" onClick={() => {
                                                        decreaseSmallCarousel();
                                                    }}><i class="fa fa-angle-left"></i></div>
                                                    <div className='d-flex'>
                                                        {smallcarouselimages[0] && <div class={`cursor-pointer  ${selected == smallcarouselimages[0].ch_img ? "smallcarousel-selected" : "smallcarousel-unselected"}`} onClick={() => {
                                                            getpicIndex(smallcarouselimages[0].ch_img);
                                                        }} style={{ backgroundImage: `url(${picurl + smallcarouselimages[0].ch_img})` }}></div>
                                                        }
                                                        {smallcarouselimages[1] && <div class={`cursor-pointer  ${selected == smallcarouselimages[1].ch_img ? "smallcarousel-selected" : "smallcarousel-unselected"}`} onClick={() => {
                                                            getpicIndex(smallcarouselimages[1].ch_img);
                                                        }} style={{ backgroundImage: `url(${picurl + smallcarouselimages[1].ch_img})` }}></div>}
                                                        {smallcarouselimages[2] && <div class={`cursor-pointer  ${selected == smallcarouselimages[2].ch_img ? "smallcarousel-selected" : "smallcarousel-unselected"}`} onClick={() => {
                                                            getpicIndex(smallcarouselimages[2].ch_img);
                                                        }} style={{ backgroundImage: `url(${picurl + smallcarouselimages[2].ch_img})` }}></div>}
                                                        {smallcarouselimages[3] && <div class={`cursor-pointer  ${selected == smallcarouselimages[3].ch_img ? "smallcarousel-selected" : "smallcarousel-unselected"}`} onClick={() => {
                                                            getpicIndex(smallcarouselimages[3].ch_img);
                                                        }} style={{ backgroundImage: `url(${picurl + smallcarouselimages[3].ch_img})` }}></div>}
                                                    </div>
                                                    <div class="cursor-pointer home-carousel-arrows" onClick={() => {
                                                        increaseSmallCarousel();
                                                    }}><i class="fa fa-angle-right"></i></div>

                                                </div>
                                            </div>
                                            <div onClick={() => {
                                                setCarousel(false);
                                                setCarouselIndex(-1)
                                                setCarouselIndex2(-1)
                                                setCarouselIndex3(-1)
                                                setCarouselTitle("");
                                                setCarouselType("");
                                                setCarouselDesc("");
                                                setCarouselAddresse("");
                                                setCarouselPic("");
                                                setSelected("")
                                            }} className='home-carousel-item3 cursor-pointer'><i class="fa fa-times"></i></div>
                                        </div> : <></>}
                                </div>
                            )
                        })
                        }
                    </div>

                    <div className='d-flex flex-row justify-content-center align-items-center mt-5'>

                        <div class="cursor-pointer home-carousel-arrows2" disabled={currentpag == 0} onClick={() => decreasePag()}><i class="fa fa-angle-left "></i></div>
                        {arraypag.slice(0, 5).map((data, index) => {
                            return (
                                <div className={`d-flex flex-row justify-content-center align-items-center pag-number-container ${(data - 1) == currentpag ? "pag-number-container-active" : ""} cursor-pointer`} onClick={() => { scrollToList((data - 1) * 6, (data) * 6, data - 1); }} >
                                    <div>{data}</div>
                                </div>
                            )
                        })}

                        <div class="cursor-pointer home-carousel-arrows2" disabled={currentpag == arraypag.length - 1} onClick={() => increasePag()}><i class="fa fa-angle-right "></i></div>
                    </div>

                </div>
            </section>

            {/* Map */}

            <div id='map' class="mapDiv">
            </div>

            {/* Vous aimez notre travail? */}

            <section class="home-vant-bg">
                <div class="home-vant-area container">
                    <div class="home-vant-left">
                        <div class="home-vant-title">Vous aimez notre travail?</div>
                        <div class="home-vant-desc">
                            Nous sommes toujours ouverts à des projets intéressants.
                        </div>
                    </div>
                    <div class="home-white-button" onClick={() => { navigation("/contact") }}>
                        <div class="home-dollar"><i style={{ fontSize: "50px", }} class="fa fa-usd"></i></div>
                        <div class="home-white-button-text">
                            Obtenir un devis
                        </div>
                    </div>
                </div>
            </section>

            <FooterMainComponent />
            <FooterComponent />

        </div>
    );
}


export default Realisations;
